import React, { lazy, Suspense, useEffect, useState } from "react";
import { Container, Row, Col, Image, Navbar, Nav } from "react-bootstrap";
import "./Webinar.css";
import htmlParser from "html-react-parser";
import MediaQuery from "react-responsive";
import ContactUsForm from "../ContactUS Form/ContactUsForm";

export default function Banner({
  WebinarHighlightsData,
  loanOfficer,
  loInformation,
}) {
  const [navbar, setNavbar] = useState(false);

  //logo scroll when active

  return (
    <>
     <div className="wegtitlediv">
        <p className="wehightitle"> {htmlParser(WebinarHighlightsData.webHigh)}</p>
        </div>
    <div className="webtitledivdiv">
      <Container>
       
        <Row>
          <Col sm={12} md={12} lg={4} xl={4}>
            <div className="thnkyoudiv">
            <p className="webtitles"> {htmlParser(WebinarHighlightsData.webHighTitle)}</p>
            <p className="webdes"> {htmlParser(WebinarHighlightsData.webHighDes)}</p>
            
            </div>
          </Col>

          <Col sm={12} md={12} lg={4} xl={4}>
          <div className="thnkyoudiv">
            <p className="webtitles"> {htmlParser(WebinarHighlightsData.webHighTitle1)}</p>
            <p className="webdes"> {htmlParser(WebinarHighlightsData.webHighDes1)}</p>
            
            </div>
          </Col>

          <Col sm={12} md={12} lg={4} xl={4}>
          <div className="thnkyoudiv">
            <p className="webtitles"> {htmlParser(WebinarHighlightsData.webHighTitle2)}</p>
            <p className="webdes"> {htmlParser(WebinarHighlightsData.webHighDes2)}</p>
            
            </div>
          </Col>
        </Row>
        <div>
        
          <p className="webhighh"> {htmlParser(WebinarHighlightsData.webHighlightdes)}</p>
          <p className="webhighh"> {htmlParser(WebinarHighlightsData.webHightoghether)}</p>
       
        </div>
      </Container>
      </div>
    </>
  );
}
